import React from "react";

const CustomCarouselPrevBtn: React.FC = () => {
  return (
    <div className="custom-carousel-control prev">
      <span className="carousel-control-prev-icon" />
    </div>
  );
};

export default CustomCarouselPrevBtn;
